// everestConfig.ts

const everestConfig = {
  colors: {
    primary: "#3EBEC8",
    secondary: "#003350",
    danger: "#ff0000",
    "supervisor-red": "#FE5A5A",
    "supervisor-orange": "#FF7E47",
    "supervisor-yellow": "#D3B603",
  },
  fontFamily: {
    sans: ["Poppins", "sans-serif"],
    serif: ["Merriweather", "serif"],
  },
  layout: {
    backButton: true, // This will be dynamically updated
  },
};

export default everestConfig;
